import React from 'react';
import PropTypes from 'prop-types';
import { AND, VIEW_MORE } from "../../../utils/default-strings";
import { Grid } from "../../layout/Grid";
import { GridRow } from "../../layout/GridRow";
import { GridColumn } from "../../layout/GridColumn";
import { Heading } from "../../typography/Heading";
import { getDefaultItems } from "./utils/getDefaultItems";
import { hasExtraItems } from "./utils/hasExtraItems";
import { getCategoryMarkup } from "./utils/getCategoryMarkup";
import { getExtraItemsMarkup } from "./utils/getExtraItemsMarkup";
import { getExtraItems } from "./utils/getExtraItems";
export var Component = function Component(_ref) {
  var id = _ref.id,
      amenities = _ref.amenities,
      hasExtraItemsInModal = _ref.hasExtraItemsInModal,
      headingText = _ref.headingText,
      isStacked = _ref.isStacked,
      modalTriggerText = _ref.modalTriggerText,
      amenitiesConjunctionText = _ref.amenitiesConjunctionText;
  return React.createElement(Grid, {
    className: "is-amenities",
    columns: isStacked ? 1 : 3,
    id: id,
    isStackable: true
  }, React.createElement(GridRow, null, headingText && React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Heading, null, headingText)), getDefaultItems(amenities, isStacked).map(function (amenity, index) {
    return getCategoryMarkup(amenity, index, amenitiesConjunctionText, isStacked);
  }), hasExtraItems(amenities, isStacked) && getExtraItemsMarkup(hasExtraItemsInModal, modalTriggerText, getExtraItems(amenities, isStacked), amenitiesConjunctionText)));
};
Component.displayName = 'Amenities';
Component.defaultProps = {
  id: null,
  hasExtraItemsInModal: false,
  headingText: null,
  isStacked: false,
  modalTriggerText: VIEW_MORE,
  amenitiesConjunctionText: AND
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  amenities: PropTypes.arrayOf(PropTypes.shape({
    iconName: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  amenitiesConjunctionText: PropTypes.string,
  hasExtraItemsInModal: PropTypes.bool,
  headingText: PropTypes.string,
  id: PropTypes.string,
  isStacked: PropTypes.bool,
  modalTriggerText: PropTypes.string
} : {};